// src/serviceshttps://laubloch.de/backend.js
import { hasConsent } from './consent.js'

async function apiCall(endpoint, options = {}) {
  if (!hasConsent()) {
    throw new Error('Keine Einwilligung zur Datenverarbeitung gegeben.')
  }

  const token = document.cookie
    .split('; ')
    .find(row => row.startsWith('auth_token='))
    ?.split('=')[1]

  const response = await fetch(`https://laubloch.de/backend${endpoint}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
      ...options.headers
    },
    credentials: 'include',
    ...options,
  })

  // Check if response is JSON by looking at content-type header
  const contentType = response.headers.get('content-type');
  const isJson = contentType && contentType.includes('application/json');

  if (!response.ok) {
    if (isJson) {
      const data = await response.json();
      throw new Error(data.error || 'Ein Fehler ist aufgetreten');
    } else {
      // If not JSON, don't try to parse it
      throw new Error('Der Server hat eine unerwartete Antwort gesendet');
    }
  }

  // For successful responses
  if (isJson) {
    return response.json();
  } else {
    // For the keyhole endpoint, we may be getting SVG instead of JSON
    const text = await response.text();
    try {
      // Try to parse it as JSON first
      return JSON.parse(text);
    } catch (e) {
      // If it's not valid JSON but the content looks like SVG
      if (text.includes('<svg') && text.includes('</svg>')) {
        return {
          success: true,
          svg: text,
          stats: null // We'll need to fetch stats separately
        };
      }
      // Otherwise return the text response
      return { success: true, content: text };
    }
  }
}

export async function getUserStats() {
  return apiCall('/account.php?action=get-stats');
}

export async function downloadNewKeyhole() {
  const response = await apiCall('/account.php?action=download-keyhole', {
    method: 'POST'
  });
  
  // If we received SVG without stats, fetch the stats separately
  if (response.success && response.svg && !response.stats) {
    try {
      const stats = await getUserStats();
      response.stats = stats;
    } catch (e) {
      console.error('Failed to fetch stats after keyhole generation:', e);
    }
  }
  
  return response;
}

export async function logout() {
  const result = await apiCall('/account.php?action=logout', {
    method: 'POST'
  });
  
  // Clear auth cookie on successful logout
  if (result.success) {
    document.cookie = 'auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }
  
  return result;
}